// extracted by mini-css-extract-plugin
export default {"root":"IconWrapper_root__C2+rV","clickable":"IconWrapper_clickable__qID8W"};